import { useEffect } from 'react';
import { usePlatformBranding } from '@/hooks/use-platform-branding';

const DEFAULT_FAVICON = '/favicon.svg';

export function BrandingRuntime() {
  const { branding } = usePlatformBranding();

  useEffect(() => {
    document.title = branding.app_name;
    let favicon = document.querySelector<HTMLLinkElement>('link[rel~="icon"]');
    if (!favicon) {
      favicon = document.createElement('link');
      favicon.rel = 'icon';
      document.head.appendChild(favicon);
    }
    favicon.href = branding.favicon_url ?? DEFAULT_FAVICON;
    if (branding.favicon_url) favicon.removeAttribute('type');
    else favicon.type = 'image/svg+xml';
  }, [branding.app_name, branding.favicon_url]);

  return null;
}
